import React, { Component } from "react"
import ReactDOM from "react-dom"

import ProRouter from "./ProRouter"
import { translate } from "react-translate"
import ProMenu from "./Header/ProMenu"

import { connect } from "react-redux"
import {
  Segment,
  Grid,
  Image,
  Header,
  Icon,
  Modal,
  Button,
  Item
} from "semantic-ui-react"

import ProFooterComponent from "./Footer/ProFooterComponent"

const mapStateToProps = state => ({})

const mapActionToProps = {}

class ConnectedProComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentWillMount() {}

  render() {
    return (
      <div>
        <ProMenu />
        <ProRouter />
        <ProFooterComponent />
      </div>
    )
  }
}

const ProComponent = connect(
  mapStateToProps,
  mapActionToProps
)(ConnectedProComponent)
export default translate("ProComponent")(ProComponent)



// WEBPACK FOOTER //
// ./src/components/Pro/ProComponent.js